import * as R from 'ramda'

import assocPath from 'coact/utils/assocPath'

import invoiceSchema from '~/src/invoice/data/invoices/schema.js'

import mergeClientRequiredChanges from '../../../utils/schema/mergeClientRequiredChanges.js'

import salesOrders from '../salesOrders.js'
import salesOrderItems from '../salesOrderItems.js'
import receivables from '../../receivables.js'

const itemSchema = mergeClientRequiredChanges(salesOrderItems.schema)
const paymentSchema = mergeClientRequiredChanges(receivables.schema)

const schema = R.pipe(
  assocPath(['contents', 'items', 'contents', 0], itemSchema),
  assocPath(['contents', 'payments', 'contents', 0], paymentSchema),
  assocPath(['contents', 'action'], { type: 'String' }), // WORKAROUND for confirmPayments
  assocPath(['contents', 'invoices', 'contents', 0], invoiceSchema),
  assocPath(['contents', 'issueAmount'], {
    type: 'Number',
    label: '此次開立金額',
  }), // for issueInvoice
)(mergeClientRequiredChanges(salesOrders.schema))

export default schema
